import { BusinessLegalStructure } from './business-legal-structure.model';
import { PropertyTax } from './property-tax.model';

export class IndustrialTaxExemptionApplication {
  productManufactured: string;
  manufacturingProcess: string;
  adValorem: number;
  annualAdValorem: number;
  llcMembers: BusinessLegalStructure[];
  affiliates: BusinessLegalStructure[];
  propertyTax: PropertyTax;
  isThisCompanyLlc: boolean;
  isCompanyAffiliated: boolean;
  hasTaxLiabilities: boolean;
  taxLiabilitiesReason: string;
  isManufacturing: boolean;
  isCompanyAuthorized: boolean;
  isCompanyFelon: boolean;
  companyFelonExplanation: string;
  willProvideRequestedDoc: boolean;

  constructor(ite?: any) {
    if (!ite) ite = {};
    this.productManufactured = ite.productManufactured || null;
    this.manufacturingProcess = ite.manufacturingProcess || null;
    this.adValorem = ite.adValorem || null;
    this.annualAdValorem = ite.annualAdValorem || null;
    this.llcMembers = ite.llcMembers || [];
    this.affiliates = ite.affiliates || [];
    this.propertyTax = ite.propertyTax || null;
    this.isThisCompanyLlc = ite.isThisCompanyLlc || false;
    this.isCompanyAffiliated = ite.isCompanyAffiliated || false;
    this.hasTaxLiabilities = ite.hasTaxLiabilities;
    this.taxLiabilitiesReason = ite.taxLiabilitiesReason;
    this.isManufacturing = ite.isManufacturing;
    this.isCompanyAuthorized = ite.isCompanyAuthorized;
    this.isCompanyFelon = ite.isCompanyFelon;
    this.companyFelonExplanation = ite.companyFelonExplanation;
    this.willProvideRequestedDoc = ite.willProvideRequestedDoc;
  }
}
